import React, { useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { useSnackbar } from 'notistack'
import { useConfirm } from "material-ui-confirm";
import axios from "axios";
import BasePopup from "../../../Components/Base/BasePopup";
//import VeiculoCadastroPopup from "./VeiculoCadastroPopup";
import DataGridBuscaComponent from "../../../Components/Forms/DataGridBuscaComponent";
import { Veiculo } from "../../../Models/Cadastros/Veiculo/Veiculo";
import VeiculoCadastroPopup from "./VeiculoCadastroPopup";

const VeiculoPesquisaPopup = (props: any) => {
    const [openCadastroPopup, setOpenCadastroPopup] = useState(false);
    const [openPopupConfirm, setOpenPopupConfirm] = useState(false);
    const [veiculo, setVeiculo] = useState<any>(new Veiculo());
    const closePopupAction = () => setOpenPopupConfirm(false);
    const handleCloseCadastroPopup = () => setOpenCadastroPopup(false);
    const { enqueueSnackbar } = useSnackbar();
    const confirm = useConfirm();

    const openCadastroPopupEventCallback = () => {
        setVeiculo(new Veiculo());
        setOpenCadastroPopup(true);
    }

    const editarVeiculo = async (id: any) => {
        let reponse: any = await axios.get(`veiculos/${id}`);
        setVeiculo(reponse.data);
        setOpenCadastroPopup(true);
    };

    const solicitaExcluirVeiculo = async (id: any) => {
        await confirm({ title: "Deseja realmente apagar este registro?" });
        enqueueSnackbar(`ID = ${id}`, {variant: 'success'});
    };

    const columns: any[] = [
        { dataIndex: 'placa', title: 'Placa', minWidth: 200, flex: 0.3, },
        { dataIndex: 'renavan', title: 'Renavan', minWidth: 200, flex: 0.3, },
        { dataIndex: 'marca', title: 'Marca', minWidth: 200, flex: 0.2, },
    ];
    
    return (
        <div>
            <BasePopup title="Veículos" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={openCadastroPopupEventCallback}>
                <DataGridBuscaComponent apiBusca="buscaVeiculos" columns={columns} onEditAction={editarVeiculo} onDeleteAction={solicitaExcluirVeiculo} fieldId='id' />
            </BasePopup>

            {openCadastroPopup ? <VeiculoCadastroPopup isOpen={openCadastroPopup} onClose={handleCloseCadastroPopup} veiculo={veiculo} /> : ''}
        </div>
    );
}

export default VeiculoPesquisaPopup;
